import _ from 'lodash';
import { FulfilmentType } from "config";

const parseDelivery = (delivery, links) => ({
    ...delivery,
    address: links[delivery.address]?.id,
    collectionLocation: links[delivery.collectionLocation],
});

export function parseRecentOrders(response) {
    const { result, links } = response;

    return result.map(order => {
        const trip = links[order.trips?.[0]] || {};
        const fare = (trip.fares?.season || trip.fares?.outwardSingle || trip.fares?.return || trip.fares?.fareOnly) || {};
        const tickets = fare?.tickets || [];
        const railcard = links?.[tickets?.[0]?.railcard];
        const adults = tickets.reduce((acc, el) => (acc + el.adults), 0);
        const children = tickets.reduce((acc, el) => (acc + el.children), 0);
        const ticketType = links[fare.ticketTypeCode] || {};
        const isSmartcard = order.delivery?.fulfilmentMethod === FulfilmentType.SMARTCARD;

        return {
            delivery: parseDelivery(order.delivery, links),
            origin: links[fare.origin],
            destination: links[fare.destination],
            id: order.id,
            route: links[fare.routeCode],
            duration: formatValidity(fare.outwardJourney?.validityPeriod),
            passenger: fare.tickets?.[0]?.passenger,
            isOpenReturn: ticketType.isReturn,
            fareClass: ticketType.isFirstClass ? 'first-class' : 'standard',
            smartTicketType: fare.smartTicketTypeCode,
            railcard,
            adults,
            children,
            ticketType,
            isSmartcard
        }
    });
}

export function formatValidity(str = '') {
    const months = +str.slice(0, 2);
    const days = + str.slice(2);

    let formatted = 'P';

    if (months) {
        formatted += months + 'M';
    }

    if (days) {
        formatted += days + 'D';
    }

    return formatted;
}

const checkIfSimilarRecentOrdersExist = (recentOrders, recentOrder) => {
    return recentOrders.find(order =>
      recentOrder.origin.nlc === order.origin.nlc &&
      recentOrder.destination.nlc === order.destination.nlc &&
      recentOrder.adults === order.adults &&
      recentOrder.children === order.children &&
      recentOrder.route.code === order.route.code &&
      recentOrder.ticketType.code === order.ticketType.code &&
      recentOrder.ticketType.isSeason === order.ticketType.isSeason &&
      recentOrder.ticketType.isReturn === order.ticketType.isReturn &&
      recentOrder.duration === order.duration
    )
};

const filterUniqRecentOrders = (recentOrders = []) => {
    return recentOrders.reduce((acc, recentOrder) => {
        const hasSimilarOrder = checkIfSimilarRecentOrdersExist(acc, recentOrder);
        return hasSimilarOrder ? acc : [...acc, recentOrder]
    }, [])
}

export const normalizeRecentOrders = _.flow(
  filterUniqRecentOrders,
  recentOrders => recentOrders.slice(0, 4),
);
